/**
 * admin/sessions — REFUSALS. The codes portal-backend refuses a session's
 * schedule by (portal-backend/src/modules/world-sessions/session-refusals.ts,
 * whose session-refusals.spec.ts holds the two alike): a session that would
 * start after its campaign's end, and a campaign end that would come before a
 * session of its starts. Read off a failed request with what each names, so
 * the admin's screens can say why in the admin's language.
 */
import { ApiError } from '../../_shared/api-error';

/** A refusal, by its code, with the campaign it names and the instant it turns on (UTC seconds). */
type SessionRefusal =
  | { code: 'SESSION_AFTER_CAMPAIGN_END'; campaignName: string; campaignEndUtc: number }
  | { code: 'CAMPAIGN_END_BEFORE_SESSION'; campaignName: string; sessionStartUtc: number };

/** The refusal a failed request carries, or null for any other failure. */
export function sessionRefusalOf(e: unknown): SessionRefusal | null {
  if (!(e instanceof ApiError) || e.status !== 400 || typeof e.body !== 'object' || e.body === null) return null;
  const body = e.body as Record<string, unknown>;
  if (typeof body.campaignName !== 'string') return null;
  if (body.code === 'SESSION_AFTER_CAMPAIGN_END' && typeof body.campaignEndUtc === 'number') {
    return { code: body.code, campaignName: body.campaignName, campaignEndUtc: body.campaignEndUtc };
  }
  if (body.code === 'CAMPAIGN_END_BEFORE_SESSION' && typeof body.sessionStartUtc === 'number') {
    return { code: body.code, campaignName: body.campaignName, sessionStartUtc: body.sessionStartUtc };
  }
  return null;
}
